/* eslint-disable import/no-cycle */
import _ from "lodash"
import { WIDGET_TYPES } from "./types"
import wealthPages, { messages as wealthMessages } from "../pages/wealth/pages"
import assetManagementPages, {
  messages as assetManagementMessages
} from "../pages/assetmanagement/pages"

const messages = { ...wealthMessages, ...assetManagementMessages }
/**
 * A sub set of all available pages (wealth / assetmanagement)
 */
export const pages = [...wealthPages, ...assetManagementPages]

export const findBundleKey = (key) =>
  _.values(messages).find((item) => item.id === key)

// TODO: Meilleure chose à faire ici ? Un enum centralisé pourrait être pas mal
const groupPages = {
  wealth: [
    "synthesis",
    "consolidation",
    "movement",
    "performance",
    "composition",
    "simulations"
  ],
  am: [
    "characteristics",
    "performances",
    "allocation",
    "documents",
    "composition"
  ]
}

/**
 * Build all combination of available aliases (ex: wealth_composition_selector_3)
 * Consider a limit of 3 alias of each types.
 * @returns {[]}
 */
export const buildAliases = () => {
  const result = []
  const nth = _.range(3)
  _.forOwn(groupPages, (subPages, group) => {
    _.forEach(subPages, (page) => {
      Object.values(WIDGET_TYPES).forEach((type) => {
        _.forEach(nth, (n) => {
          result.push(`${group}_${page}_${_.toLower(type)}_${n}`)
        })
      })
    })
  })
  return result
}
